export class Firm {
    id:number;
    name:string;
}
